<div class="container">
  @if (successMsg | async) {
    <div class="alert alert-info" role="alert">
      <i class="fas fa-lg fa-info-circle"></i>&ensp;{{successMsg | async}}
    </div>
  }
  @if (warningMsg | async) {
    <div class="alert alert-warning" role="alert">
      <i class="fas fa-lg fa-exclamation-circle"></i>&ensp;{{warningMsg | async}}
    </div>
  }
  @if (errorMsg | async) {
    <div class="alert alert-danger" role="alert">
      <i class="fas fa-lg fa-exclamation-triangle"></i>&ensp;{{errorMsg | async}}
    </div>
  }
</div>